/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import {
    Stack,
    Grid,
    GridItem,
    Container,
    Skeleton,
    Box,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useIntl} from 'react-intl'
import Seo from '../../../components/seo'

const CartSkeleton = () => {
    const styles = useMultiStyleConfig('Cart')
    const {formatMessage} = useIntl()
    const cartPageTitle = formatMessage({
        id: 'cart.page.title',
        defaultMessage: 'My Shopping Bag | Garage Clothing UK'
    })
    const cartPageDescription = formatMessage({
        id: 'cart.page.description',
        defaultMessage: 'My Shopping Bag | Garage Clothing UK'
    })

    return (
        <>
            <Seo title={cartPageTitle} description={cartPageDescription} noIndex noFollow />
            <Box sx={styles.skeletonWrapper}>
                <Container sx={styles.skeletonContainer}>
                    {/* Banner placeholder — matches Optimizely banner space + 32px gap */}
                    <Skeleton
                        height={{base: '100px', lg: '100px'}}
                        width="full"
                        borderRadius="md"
                        mb={16}
                    />
                    <Grid
                        templateColumns={{base: '1fr', lg: '66% 1fr'}}
                        gap={{base: 10, xl: 20}}
                        width="full"
                    >
                        <GridItem maxW="full" minWidth={0}>
                            <Skeleton sx={styles.skeletonTitle} />
                            <Box sx={styles.skeletonApproaching} />
                            <Stack spacing={{base: '10px', lg: '14px'}} mb="7">
                                {[0, 1, 2].map((i) => (
                                    <Skeleton key={i} sx={styles.skeletonItem} />
                                ))}
                            </Stack>
                        </GridItem>
                        <GridItem maxW="full">
                            <Skeleton sx={styles.skeletonSummary} />
                        </GridItem>
                    </Grid>
                </Container>
            </Box>
        </>
    )
}

export default CartSkeleton
